import styles from "./snowiespace.module.css";

export function ui(...names: Array<string | false | null | undefined>): string {
  return names
    .filter((name): name is string => Boolean(name))
    .flatMap((name) => name.trim().split(/\s+/))
    .map((name) => styles[name] ?? name)
    .join(" ");
}
